import { Warning, WhatsappLogo } from 'phosphor-react'
import { useEffect, useState } from 'react'
import { Badge, Button, Col, Container, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner'
import RequestHistorical from '../../../../components/RequestHistorical'
import DeliveryMap from '../../../../components/Vehicle/Map/DeliveryMap'
import { useLoading } from '../../../../hooks/LoadingContext'
import DashboardLayout from '../../../../layouts/Dashboard'
import api from '../../../../services/api'
import { getWaypointsTotalDistance } from '../../../../utils/distanceUtils'
import { errorApi } from '../../../../utils/errorApi'
import { openWindow } from '../../../../utils/whatsapp'
import styles from './styles.module.css'

interface IRequest {
  id: number
  delivery_id: number
  invoice: string
  request_number: string
  invoice_number: string
  receiver_name: string
  phone: string
  status: string
  cep: string
  city: string
  state: string
  neighborhood: string
  street: string
  street_number: string
  complement: string
  start_date: Date
  weight: number
  updated_at: string
  delivering_image_url: string
  delivering_image_key: string
  customer_rating_stars: number
  customer_rating_text: string
  request_delivery_driver_note: string
  request_delivery_time_seconds: number
  request_delivery_distance_meters: number
  vehicle_id: number
  vehicle_board: string
  driver_id: number
  driver_name: string
  delivery_had_problems: boolean
}

interface IVehicle {
  id: number
  board: string
  model: string
  color: string
  driver_name: string
  driver_phone: string
}

const EntregaInfo: React.FC = () => {
  const [request, setRequest] = useState<IRequest>()
  const [reports, setReports] = useState<any>()
  const [totalDistance, setTotalDistance] = useState<string>()
  const [waypoints, setWaypoints] = useState<any>()
  const [vehicleId, setVehicleId] = useState<number>()
  const [vehicle, setVehicle] = useState<IVehicle>()

  const { isLoading, setIsLoading } = useLoading()

  const { id } = useParams()

  useEffect(() => {
    async function loadData() {
      if (!id) return

      try {
        setIsLoading(true)
        const { data } = await api.get(`/delivery-manager/requests/${id}`)
        setRequest(data)
      } catch (e) {
        toast.error(errorApi(e, 'Erro ao buscar dados da entrega'))
      }
      setIsLoading(false)
    }

    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    if (!request) return

    async function loadVehicle() {
      try {
        setIsLoading(true)
        const { data } = await api.get(
          `/delivery-manager/deliveries/${request!.delivery_id}?driverInfo=true`,
        )
        setVehicleId(data.vehicle_id)
      } catch (e) {}

      setIsLoading(false)
    }

    loadVehicle()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request])

  useEffect(() => {
    async function loadVehicle() {
      if (!vehicleId) return
      try {
        setIsLoading(true)
        const { data } = await api.get(
          `/delivery-manager/vehicles/${vehicleId}?driverInfo=true`,
        )
        setVehicle(data)
      } catch (e) {
        console.error(errorApi(e, 'Erro ao buscar informações do veículo'))
      }

      setIsLoading(false)
    }

    loadVehicle()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleId])

  useEffect(() => {
    async function loadWaypointsData() {
      if (!id) return

      if (request?.status !== 'on_route' && request?.status !== 'delivered') return

      setIsLoading(true)
      try {
        const { data } = await api.get(`/delivery-manager/requests/${id}/waypoints`)

        setWaypoints(data.waypoints)
      } catch (e) {
        console.error(e)
      }
      setIsLoading(false)
    }
    loadWaypointsData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, request])

  useEffect(() => {
    if (!waypoints) return
    const distance = (getWaypointsTotalDistance(waypoints) / 1000).toFixed(2)

    setTotalDistance(distance)
  }, [waypoints])

  useEffect(() => {
    async function loadReports() {
      if (!request) return
      try {
        setIsLoading(true)
        const { data } = await api.get(`/delivery-manager/delivery-reports/${request?.delivery_id}`)
        const reports = data.deliveryReports.filter(
          (report: any) => report.request_id === Number(id),
        )

        setReports(reports)
      } catch (e) {
        console.error(errorApi(e, 'Erro ao buscar informações da entrega'))
      }

      setIsLoading(false)
    }

    loadReports()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request])

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Informações da entrega">
      <LoadingSpinner text="Buscando dados da entrega. Aguarde..." />
      <Container>
        <Row className="text-md-left mt-4">
          <Col>
            <Row>
              <h4>
                {`Entrega do pedido ${request?.request_number ?? request?.invoice.substring(0, 10) + '...'} | ${vehicle?.model} ${
                  vehicle?.color
                } dirigido por ${vehicle?.driver_name || 'Desconhecido'}`}
              </h4>
            </Row>
            <Row className="">
              {request ? (
                <>
                  {request.status === 'on_route' || request.status === 'delivered' ? (
                    <Col className="w-100">
                      {waypoints && waypoints.length > 0 ? (
                        <Row style={{ height: 400, width: '100%', marginLeft: 7 }}>
                          <DeliveryMap requestId={request.id} role="delivery-manager" />
                        </Row>
                      ) : (
                        <Row>
                          <Col className="col-12">
                            <div className="text-center mt-2 mb-3">
                              <Badge
                                bg="#053C5E"
                                style={{
                                  maxWidth: 'fit-content',
                                  backgroundColor: '#053C5E',
                                  wordBreak: 'break-word',
                                  whiteSpace: 'normal',
                                }}
                              >
                                O trajeto da entrega ainda é desconhecido. Tente novamente mais
                                tarde.
                              </Badge>
                            </div>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col className="col-12">
                          <div className="text-center mt-2 mb-3">
                            <Button
                              className={styles.btnWhatsapp}
                              disabled={!vehicle?.driver_phone}
                              onClick={() => openWindow(vehicle?.driver_phone)}
                            >
                              <WhatsappLogo
                                style={{ marginRight: 3, marginTop: -3 }}
                                size={20}
                              ></WhatsappLogo>
                              Entrar em contato com o motorista
                            </Button>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <h4 className="text-left mt-4 mt-md-3 mb-3">Histórico da entrega</h4>
                          <Row>{reports && <RequestHistorical reportsInfo={reports} />}</Row>
                        </Col>
                        <Col md={6}>
                          <h4 className="text-left mt-4 mt-md-3 mb-3">Informações da entrega</h4>
                          {!isLoading && (
                            <Row
                              className={`${styles.infoContainer} border d-flex flex-column justify-content-center align-items-start`}
                            >
                              <span className={styles.infoTitle}>
                                Destinatário:{' '}
                                <span className={styles.infoValue}>{request.receiver_name}</span>
                              </span>
                              <span className={styles.infoTitle}>
                                Telefone:{' '}
                                <span className={styles.infoValue}>
                                  {request.phone || 'Não informado'}
                                </span>
                              </span>
                              <span className={styles.infoTitle}>
                                Kms rodados na entrega:{' '}
                                <span className={styles.infoValue}>{totalDistance || 0} km</span>
                              </span>
                              <span className={styles.infoTitle}>
                                Peso transportado:{' '}
                                <span className={styles.infoValue}>{request.weight} kg</span>
                              </span>
                            </Row>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  ) : (
                    <Badge>Entrega não iniciada!</Badge>
                  )}
                </>
              ) : (
                <Badge bg="#053C5E" text="white" className={styles.noRequestsBadge}>
                  <Warning style={{ marginBottom: 2 }} color="#ffffff" size={15} weight="bold" />{' '}
                  Entrega não encontrada!
                </Badge>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </DashboardLayout>
  )
}

export default EntregaInfo
